interface ShippingOption {
    value: string
    name: string
    price: string
    isSelected?: boolean
}

interface Fields {
    [key: string]: {
        type: string
        required?: boolean
        visible?: boolean
    }
}

type ShippingOptionType = ShippingOption

function getShippingOptions(cart: any): ShippingOptionType[] {
    return (
        cart?.checkoutApiSelection?.shippingMethods.map((option: any) => ({
            value: option.shippingMethod,
            name: option.name,
            price: option.price,
            isSelected:
                cart?.checkoutApiSelection?.selection?.shippingMethod ===
                option.shippingMethod
        })) ?? []
    )
}

function removeFields(obj: Fields | undefined): Fields | undefined {
    if (!obj) return undefined

    delete obj.email
    delete obj.firstName
    delete obj.lastName
    delete obj.country
    delete obj.vatNumber
    delete obj.company
    delete obj.newsletter

    return obj
}

interface Field {
    type: string
    required?: boolean
    visible?: boolean
}
function objectToArray(obj: any) {
    const fieldArray: Field[] = Object.values(obj)
    return fieldArray
}

export { getShippingOptions, removeFields, objectToArray }
